import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmEmail } from "@shared/services/cog_authService";

export default function ConfirmSignup() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await confirmEmail({
        email: state?.email,
        confirmationCode: code,
      });
      navigate("/login", { state: { email: state?.email } });
    } catch (err) {
      setError(
        err?.message ||
          err?.response?.data?.message ||
          err?.response?.data?.detail ||
          "Confirmation failed",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Verify Your Email</h2>
      <p>
        Enter the code sent to <strong>{state?.email}</strong>
      </p>
      <form onSubmit={handleSubmit}>
        <input
          placeholder="Verification Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? "Confirming..." : "Confirm"}
        </button>
      </form>
    </div>
  );
}
